const translations = {
  title: 'Formulários',
  'menu.triggers': 'Automações',
  'menu.integrations': 'Integrações',
  name: 'Nome',
  checklist: 'Questionário',
  replies: 'Respostas',
  access: 'Acesso',
  cardsView: 'Visão de cards (em breve)',
  requiredAnswersMissing: 'Respostas obrigatórias faltando',
  requiredAnswersMissingMessage: 'Verifique as perguntas com as tags vermelhas.',
  successTitle: 'Formulário respondido com sucesso!',
  successBody: 'Obrigado pelas respostas',
  sentSuccessfully: 'Enviado com sucesso.',
  alreadyRepliedTitle: 'Formulário já respondido',
  alreadyRepliedDescription: 'Você não pode responder este formulário, pois ele já foi respondido no dia {{date}}',
  bulkRegistration: 'Cadastro em massa',
  sendHistory: 'Histórico de envios',
  removeConfirm: 'Certeza que deseja remover?',
  removeError: 'Ocorreu um erro ao deletar!',
  exportToExcel: 'Exportar para Excel',
  resume: 'Resumo',
  share: 'Compartilhar',
  sendHistoryMenu: 'Histórico de Envios',
  logs: 'Logs',
  edit: 'Editar',
  remove: 'Remover',
  sendDate: 'Data do envio',
  invites: 'Convites',
  replied: 'Respondidos',
  resend: 'Enviar novamente'
}

export default translations
